export function getApiErrorMessage(error, fallback: string): string {
  const message = error?.response?.data?.message;
  return (Array.isArray(message) ? message.join(", ") : message) || error?.message || fallback;
}
